
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M23.479 29.691a2.325 2.325 0 01-1.089-.27l-6.233-3.276a.333.333 0 00-.314 0l-6.232 3.276a2.338 2.338 0 01-3.393-2.465l1.19-6.939a.337.337 0 00-.1-.3L2.27 14.8a2.338 2.338 0 011.3-3.989L10.533 9.8a.337.337 0 00.254-.185L13.9 3.3a2.337 2.337 0 014.193 0l3.115 6.313a.34.34 0 00.254.185l6.969 1.012a2.339 2.339 0 011.3 3.989l-5.043 4.914a.339.339 0 00-.1.3l1.19 6.939a2.341 2.341 0 01-2.3 2.735zM16 24.105a2.325 2.325 0 011.088.27l6.232 3.275a.321.321 0 00.356-.025.325.325 0 00.135-.331l-1.191-6.94a2.343 2.343 0 01.672-2.069l5.043-4.915a.338.338 0 00-.188-.576l-6.968-1.013a2.335 2.335 0 01-1.76-1.279L16.3 4.188a.338.338 0 00-.606 0L12.581 10.5a2.335 2.335 0 01-1.761 1.279l-6.967 1.015a.337.337 0 00-.187.576l5.042 4.915a2.343 2.343 0 01.672 2.069l-1.191 6.94a.338.338 0 00.492.356l6.231-3.276A2.335 2.335 0 0116 24.105z","fill":"#fff","data-original":"#000000"}})])
          )
        }
      }
    